import axios from "axios";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { IQueryBase, OctResponse } from "../../models/OctResponse";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";
import { localStorageItem } from "../../utils/LocalStorage";

const BASE_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] ||
	process.env.REACT_APP_API_URL;

export const getPatients = async (params: IQueryBase) => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/patient/search`, {
		params,
	});
	return data;
};

export const getPatientDetail = async (patientId: string) => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/patient/${patientId}`);
	return data;
};

export const getMedicalRecordLink = async (params: {
	medicalRecordCode: string;
	system: string;
}) => {
	const { data } = await axios.post<OctResponse<any>>(`${BASE_URL}/emr/integration/send`, params);
	return data;
};
